<template>
  <page-error
    class="v-error403"
    :code="403"
    :message="$t('Looks like you don\'t have permission to access this page. Reach out to system administrator to gain access.')"
    :title="$t('Access denied')"
  />
</template>

<script>
  import PageError from '@/common/components/PageError.vue';

  export default {
    name: 'Error403',
    components: {
      PageError
    }
  };
</script>
